/* Copyright 2013 - 2024 Waiterio LLC */
const userAgent = window?.navigator?.userAgent ?? ''

export default userAgent
